import React, { useEffect, useState } from 'react'
import { Col, Button, Menu, Dropdown, Row, Tooltip, Form, Popover, Divider, Modal, Checkbox } from 'antd'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import SelectField from 'components/SelectField'
import TableComponent from 'components/Table'
import SortableColumn from 'components/Table/ColumnSort'
import SearchableColumn from 'components/Table/ColumnSearch'
import CustomTooltip from 'components/Tooltip'
import InnerTable from './InnerTable'
import TransfersHeader from './TransferHeader'
import TransfersFooter from './TransfersFooter'
import FullScreenLoading from 'components/FullScreenLoading'
import Icon from '@ant-design/icons'
import { TransferStatus } from './TransfersStatus'
// import NextModal from 'components/NextModal'
import {
  NavigationLeftIco,
  TabsInfoIco,
  ArrowDownIco,
  ArrowUpIco,
  AccountMoreIco,
  InnerReloadIco,
  ModalCloseIco,
} from '../../../modules/CustomIcons'


import { BUTTONS, OWNACCOUNT } from 'constants/constants'
import '../Salary/index.scss'
import './index.scss'
import { useTranslation } from 'react-i18next'
import {
  checkTransferData,
  createPayment, deletePayment, getBatchPaymentsData,
  getPaymentByPackageNumber,
  uploadPayment
} from "../../services/MassTransfers/MassTransferFile";
import moment from "moment/moment";
import { CardsStatement } from "../../services/account";
import { getBatchExcel, getBusinessDate, getPaymentOrderPdfByIbanRef, getPaymentOrderPdfByIbanRefMultiple } from '../../services/transfers'
import {
  modalDataTransfersAZIPSXOHKS,
  modalDataTransfersDXA,
  modalDataTransfersFP,
  modalDataTransfersFX, modalDataTransfersGPP,
  modalDataTransfersIM,
  modalDataTransfersIT,
  modalDataTransfersPI,
  modalDataTransfersPT, modalDataTransfersPV,
  modalDataTransfersRUB,
  modalDataTransfersSP,
  modalDataTransfersXV,
  typeRender
} from '../../pages/Transfers/TypeStatusRender'
import { financial, dateFormatter } from '../../services/helper'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import { renderTextforBatch } from 'pages/Transfers/StatusRender'
import { colors } from '@mui/material'
import { getCurrentCompany } from '../../services/user'
import i18next from "../../../i18n";
import useResponsiveWidth from 'hooks/useResponsiveWidth'

// const modalData = {
//   // modalTitle: t("transfers.transferDetails"),
//   groups: [
//     {
//       title: false,
//       tableHasBorderBottom: true,
//       data: [
//         {
//           label: 'Köçürmənin kodu',
//           value: 'AZ',
//         },
//         {
//           label: t("transfers.transferType"),
//           value: 'AZİPS',
//         },
//         {
//           label: t("salary.documentNo"),
//           value: '#AZ0000700',
//         },
//         {
//           label: t("transfers.fromAccount"),
//           value: 'AZ70BRES0038138400246294578',
//         },
//         {
//           label: t("newTransfer.beneficiaryName"),
//           value: 'MEDİA TÜRK MMC',
//         },

//         {
//           label: 'Alanın hesab nömrəsi',
//           value: 'AZ70BRES003813840024629455646',
//         },
//         {
//           label: 'Alanın VÖEN',
//           value: '2902865301',
//         },
//         {
//           label: 'Alanın bankının kodu',
//           value: '',
//         },
//         {
//           label: 'Alanın bankının adı',
//           value: '',
//         },
//         {
//           label: t("transfers.infoForBeneficiary"),
//           value: 'Salam',
//         },
//         {
//           label: t("common.amount"),
//           value: '2.02',
//         },
//         {
//           label: t("home.commission"),
//           value: '0.00',
//         },
//         {
//           label: t("accountStatement.paymentDetails"),
//           value: 'Müqavilə üzrə AZİPS köçürməsi',
//         },
//         {
//           label: t("accountStatement.paymentDetails"),
//           value: 'Müqavilə üzrə AZİPS köçürməsi',
//         },
//         {
//           label: t("newTransfer.note"),
//           value: 'məlumat ...',
//         },
//         {
//           label: 'Status',
//           value: t('transfers.waitingForVerification'),
//         },
//       ],
//     },
//   ],
//   buttons: {
//     cancelButton: false,
//   },
// }

// const modalDataSuccess = {
//   // modalTitle: t("transfers.transferDetails"),
//   groups: [
//     {
//       title: false,
//       tableHasBorderBottom: true,
//       data: [
//         {
//           label: 'Köçürmənin kodu',
//           value: 'AZ',
//         },
//         {
//           label: t("transfers.transferType"),
//           value: 'AZİPS',
//         },
//         {
//           label: t("salary.documentNo"),
//           value: '#AZ0000700',
//         },
//         {
//           label: t("transfers.fromAccount"),
//           value: 'AZ70BRES0038138400246294578',
//         },
//         {
//           label: t("newTransfer.beneficiaryName"),
//           value: 'MEDİA TÜRK MMC',
//         },

//         {
//           label: 'Alanın hesab nömrəsi',
//           value: 'AZ70BRES003813840024629455646',
//         },
//         {
//           label: 'Alanın VÖEN',
//           value: '2902865301',
//         },
//         {
//           label: 'Alanın bankının kodu',
//           value: '',
//         },
//         {
//           label: 'Alanın bankının adı',
//           value: '',
//         },
//         {
//           label: t("transfers.infoForBeneficiary"),
//           value: 'Salam',
//         },
//         {
//           label: t("common.amount"),
//           value: '2.02',
//         },
//         {
//           label: t("home.commission"),
//           value: '0.00',
//         },
//         {
//           label: t("accountStatement.paymentDetails"),
//           value: 'Müqavilə üzrə AZİPS köçürməsi',
//         },
//         {
//           label: t("accountStatement.paymentDetails"),
//           value: 'Müqavilə üzrə AZİPS köçürməsi',
//         },
//         {
//           label: t("newTransfer.note"),
//           value: 'məlumat ...',
//         },
//         {
//           label: 'Status',
//           value: t('transfers.waitingForVerification'),
//         },
//         {
//           label: '“Köçürmələr”də yaranma tarixi',
//           value: '14.02.2022  15:57',
//         },
//         {
//           label: '“Köçürmələr”də yaratdı',
//           value: 'samire',
//         },
//       ],
//     },
//   ],
//   buttons: {
//     cancelButton: false,
//   },
// }

const Transfers: React.FC<any> = () => {
  const { t } = useTranslation()
  const tableDropDown = (
    <Menu className="hesablar_dropdown hesablar_dropdown--transfers">
      <Menu.Item icon={<Icon component={() => <TabsInfoIco />} />}>
        <Link to={'/'}>{t("salary.errorReport")}</Link>
      </Menu.Item>
    </Menu>
  )
  const [pageSize, setPageSize] = useState(10)
  const [current, setCurrent] = useState(1)
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [popupType, setPopupType] = useState("success")
  const [modalText, setModalText] = useState<string>("")

  const [searchable, setSearchable] = useState(false)
  const [expandedKeys, setExpandedKeys] = useState([])
  // const [modalDataState, setModalData] = useState({})
  const [tableList, setTableFilterList] = useState([])
  const [buttonClicked, setButtonClicked] = useState(0);
  const [selectedRowKeys, setCheckedList] = useState([])
  const [innerCheckList, setInnerCheckList] = useState([])
  const [packageNumberInner, setpackageNumberInner] = useState('')
  const [createDisabled, setCreateDisabled] = useState(true)
  const [checkDisabled, setCheckDisabled] = useState(false)
  const [disabledXLS, setDisabledXLS] = useState(true)
  const [loadCreate, setLoadCreate] = useState(false)
  const [loadCheck, setLoadCheck] = useState(false)
  const [applyLoading, setApplyLoading] = useState(false)
  const [checkedTransfers, setChechkedTransfer] = useState([])
  const [tempArray, setTempArray] = useState([])
  const [statusLoading, setStatusLoading] = useState(false)
  const [disablePDF, setdisablePDF] = useState(true)
  const [disableDelete,setDisabledDelete] = useState(true)
  const [packageNumber, setpackageNumber] = useState([])
  const [singlePdf, setSinglePdf] = useState([])
  const [loadingExcel,setloadingExcel] = useState(false)
  const [loadingPdf, setLoadingPdf] = useState(false)
  const [loadingPdfinner, setLoadingPdfinner] = useState(false)
  const [packageNumberForCheck, setpackageNumberForCheck] = useState([])
  const [deleteModalvisible, setDeleteModal] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [innerTableData, setInnerTableData] = useState([])
  const [packageStatus,setPackageStatus] = useState('')
  const [form] = Form.useForm()
  const dateFormat = 'DD.MM.YYYY'
  const [startDate, setStartDate] = useState(moment(new Date(), dateFormat))
  const [endDate, setEndDate] = useState(moment(new Date(), dateFormat))
  const [filtereValues, setFilteredValues] = useState({ "date": "", "packageN": "", "packageName": "", "transferType": "", "currency": '', "status": '' })
  const [tableListForSortOriginal, setTableListForSortOriginal] = useState<any>();
  const [erroredData, setErroredData] = useState([])
  const [dateList, setDateList] = useState([]);
  const [allinnerData, setallinnerData] = useState([])
  const [bussinesDate, setBusinessDate] = useState('')
  const [buttonLoading, setButtonLoading] = useState(false)
  const [packModalVisible, setpackModalVisible] = useState(false)
  const [packageNumberForDelete,setPackageNumberForDelete] = useState([])
  const [deletedTransfersLength,setDeletedTransfersLength] = useState(0)
  const [currencyFilter, setCurrencyFilter] = useState([])
  const [tableLoading, settableLoading] = useState(false)
  const history = useHistory()
  const language = localStorage.getItem("i18nextLng")
  const [statusfilter,setStatusFilter] = useState([])
  const [clickedFromTooltip, setClickedFromTooltip] = useState(false);
  let boolTooltip = false;
  
  const statusFilterDemo = [
    {
      label: t("common.all"),
      code: 'all',
      value: 'all'
    },
    {
      label: t('transfers.waitingForVerification'),
      code: 'BATCH_CHECK_WAITING',
      value: 'BATCH_CHECK_WAITING'

    },
    {
      label: t("transfers.errorsDetectedChecking"),
      value: 'BATCH_CHECK_ERROR',
      code: 'BATCH_CHECK_ERROR,',
    },
    {
      label: t("transfers.checking"),
      value: 'BATCH_CHECK_START',
      code: 'BATCH_CHECK_START',
    },
    {
      label: t("transfers.waitingForCreation"),
      value: 'BATCH_WAITING_CREATE',
      code: 'BATCH_WAITING_CREATE',
    },
    {
      label: t("transfers.errorsCreating"),
      value: 'BATCH_PAYMENTERROR',
      code: 'BATCH_PAYMENTERROR',
    },
    {
      label: t("transfers.creatingTransfers"),
      value: 'BATCH_START_CREATE',
      code: 'BATCH_START_CREATE',
    },
    {
      label: t('transfers.CreatedTransfers'),
      value: 'BATCH_FORPAYMENT',
      code: 'BATCH_FORPAYMENT',
    }, {
      label: t("transfers.forSigning"),
      value: 'PENDING_SIGNER',
      code: 'PENDING_SIGNER',
    },
    {
      label: t("transfers.expired"),
      value: 'EXPIRED',
      code: 'EXPIRED',
    }
    , {
      value: 'CLOSED',
      label: t("transfers.executed")
    },
    {
      value: 'PENDING_SIGNER',
      label: t("transfers.forSigning")
    },
    {
      value: 'PENDING_APPROVER',
      label: t("transfers.forConfirmation")
    },
    {
      value: 'PENDING_ALL',
      label: t("transfers.signConfirmation")
    },
    {
      value: 'SEND_TO_BANK',
      label: t("transfers.inProcess"),
    },
    {
      value: 'BANK_ERROR',
      label: t("transfers.notProcessed")
    },
    {
      value: 'BANK_SUCCESS',
      label: t("transfers.sentToBank")
    },
    {
      value: 'BANK_REJECTED',
      label: t("transfers.rejected")
    },
    {
      value: 'DELETED',
      label: t("transfers.deleted")
    }
  ]
  const headerInfo =
    'Eyni vaxtda yalnız bir paket üzrə iş aparıla bilər.“Köçürmələri yoxla” və “”Köçürmələr”-də yarat” düymələri yalnız paketdə olan bütün köçürmələr seçildikdə aktiv olur, tərkibində qismən yoxlanılmış və ya “Köçürmələr”-də yaradılmış köçürmələr olsa belə.Köçürmənin silinməsi bir və ya bir neçə köçürmə üzrə aparıla bilər, o halda ki, onlar “”Köçürmələr”-də yaradıldı» statusunda deyildir.'



  const fetchData = async () => {
    settableLoading(true)
    const bussinesDate: any = await getBusinessDate(language)
    setBusinessDate(bussinesDate)
    setEndDate(moment(bussinesDate, "DD.MM.YYYY"))

    const data = await getBatchPaymentsData(language,startDate, moment(bussinesDate, "DD.MM.YYYY"),)

    let temp_array: any = []
    let uniqueCurrencies: any = [];
    let temp_dates = [{ label: t("common.all"), value: 'all' }];
    data.packages?.map((row: any, index: any) => {
      const entries = Object.entries(row.trnTypeSummary)

      uniqueCurrencies.push(row.ccyType);
      let arr: any = []
      let shownValue: any = ''
      entries?.map((row,index) => {
       
        if (row[0] !== undefined && row[0] !== null) {
          let typeRender1 = typeRender(row[0])+" " + `(${row[1]})`
          shownValue += index!== entries.length-1 ? row[0] + `(${row[1]})` + ", " : row[0] + `(${row[1]}) `
          // arr += index!==entries.length-1 ?  `${typeRender1}, ` : `${typeRender1} `
          arr += index!==entries.length-1 ?  typeRender1 + "<br/>" : typeRender1
        }
      })
      let filter_date = moment(row.createDate).format("DD.MM.YYYY");
      let check_date = temp_dates.find(row => row.value == filter_date);

      if (!check_date) {
        temp_dates.push({ label: filter_date, value: filter_date })
      }


      temp_array.push({
        key: row.packageNumber,
        date: moment(row.createDate).format("DD.MM.YYYY HH:mm"),
        packageN: row.packageNumber,
        packageName: row.batchName,
        transferType: arr,
        trnTypeStr: shownValue,
        amount: financial(row.totalAmount),
        currency: row.ccyType,
        status: row.batchStatus,
        trnListDTO: row.trnList,
        modalData: [
          {
            label: t("transfers.fromAccount"),
            value: row.nickName !== null && row.nickName !== "" ? row.nickName : row.CUSTACC,
          },
          {
            label: t("transfers.totalCommission"),
            value: financial(row.totalCommAmount) + " " + `${row.ccyType !== null ? row.ccyType : ''}`,
          }, {
            label: t("transfers.NumberOfTransfers"),
            value: row.trnList?.length,
          }, {
            label: t("transfers.batchUploadedBy"),
            value: row.createUser,
          }
        ],

      })

    })

    setTableFilterList(temp_array)
    setTableListForSortOriginal(temp_array)

    let temp_currency: any = [{ label: t("common.all"), value: 'all' }];
    let temp_status: any = [{ label: t("common.all"), value: 'all' }];
    data.packages?.map(item => {

      let check_currency = temp_currency.find(row => row.value == item.ccyType && item.ccyType !== undefined);

      if (!check_currency && item.ccyType !== null) {
        temp_currency.push({
          label: item.ccyType,
          value: item.ccyType
        })
      }
      let check_status = temp_status.find(row => row.value == item.batchStatus && item.batchStatus !== undefined);

      if (!check_status && item.batchStatus !== null) {
        temp_status.push({
          label: statusFilterDemo.find(row=>row.value=== item.batchStatus)?.label,
          code: statusFilterDemo.find(row=>row.value=== item.batchStatus)?.code,
          value: item.batchStatus
        })
      }


    });

    setCurrencyFilter(temp_currency);
    settableLoading(false)
    setDateList(temp_dates)
    setStatusFilter(temp_status)
  }


  useEffect(() => {
    fetchData()
  }, []);

  const handleFilterColumn = (e: any, column: string) => {

    let newfiltereValues = filtereValues;
    if (column === 'date') {
      newfiltereValues.date = e?.toLowerCase()
      newfiltereValues.packageN = ''
      newfiltereValues.packageName = ''
      newfiltereValues.transferType = ''
      form.setFieldsValue({ "packageN": "" })
      form.setFieldsValue({ "packageName": "" })
      form.setFieldsValue({ "transferType": "" })
      form.setFieldsValue({ "status": "" })
      form.setFieldsValue({ "currency": "" })

      setFilteredValues(newfiltereValues)
    }

    if (column === 'packageN') {
      newfiltereValues.packageN = e.target.value?.toLowerCase()
      newfiltereValues.packageName = ''
      newfiltereValues.transferType = ''
      form.setFieldsValue({ "packageName": "" })
      form.setFieldsValue({ "transferType": "" })
      form.setFieldsValue({ "status": "" })
      form.setFieldsValue({ "currency": "" })

      setFilteredValues(newfiltereValues)
    }

    if (column === 'packageName') {
      newfiltereValues.packageName = e.target.value?.toLowerCase()
      newfiltereValues.packageN = ''
      newfiltereValues.transferType = ''
      newfiltereValues.currency = ''
      newfiltereValues.status = ''
      form.setFieldsValue({ "packageN": "" })
      form.setFieldsValue({ "transferType": "" })
      form.setFieldsValue({ "status": "" })
      form.setFieldsValue({ "currency": "" })
      setFilteredValues(newfiltereValues)
    }

    if (column === 'transferType') {
      newfiltereValues.transferType = e.target.value?.toLowerCase()
      newfiltereValues.packageN = ''
      newfiltereValues.packageName = ''
      newfiltereValues.currency = ''
      newfiltereValues.status = ''
      form.setFieldsValue({ "status": "" })
      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "packageN": "" })
      form.setFieldsValue({ "packageName": "" })
      setFilteredValues(newfiltereValues)
    }

    if (column === "currency") {

      newfiltereValues.currency = e.toLowerCase()
      newfiltereValues.status = ''
      newfiltereValues.packageN = ''
      newfiltereValues.packageName = ''
      newfiltereValues.transferType = ''
      form.setFieldsValue({ "status": "" })
      form.setFieldsValue({ "transferType": "" })
      form.setFieldsValue({ "packageN": "" })
      form.setFieldsValue({ "packageName": "" })
      setFilteredValues(newfiltereValues)
    }
    if (column === "status") {

      newfiltereValues.status = e.toLowerCase()
      newfiltereValues.currency = ''
      newfiltereValues.packageN = ''
      newfiltereValues.packageName = ''
      newfiltereValues.transferType = ''
      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "transferType": "" })
      form.setFieldsValue({ "packageN": "" })
      form.setFieldsValue({ "packageName": "" })
      setFilteredValues(newfiltereValues)
    }
    if (tableList && filtereValues) {

      let filteredData: any;

      filteredData = tableListForSortOriginal?.filter((sRow: any) => (
        sRow.date.split(' ')[0].toLowerCase().includes(filtereValues["date"]) &&
          sRow.packageN ? sRow.packageN?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').
            includes(filtereValues["packageN"]) : filtereValues["packageN"] === '' ? sRow.packageN === null : "")
        && (sRow.packageName ? sRow.packageName?.toLowerCase().normalize().
          replace(/[\u0300-\u036f]/g, '').includes(filtereValues["packageName"]) : filtereValues["packageName"] === '' ? sRow.packageName === null : "")
        &&
        (sRow.currency ? sRow.currency?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["currency"]) :
          filtereValues["currency"] === '' ? sRow.currency === null : ""
        )
        &&
        (sRow.status ? sRow.status?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["status"]) :
          filtereValues["status"] === '' ? sRow.status === null : ""
        )
        &&
        (sRow.trnTypeStr ? sRow.trnTypeStr?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["transferType"]) :
          filtereValues["transferType"] === '' ? sRow.trnTypeStr === null : ""));
  
          setTableFilterList(old_data => filteredData);

      if (filtereValues["currency"] === 'all') {
        setTableFilterList(tableListForSortOriginal)
        form.setFieldsValue({ "status": "" })
      }

      if (filtereValues["date"] === 'all') {
        setTableFilterList(tableListForSortOriginal)

      }

      if (filtereValues["status"] === 'all') {
        setTableFilterList(tableListForSortOriginal)
        form.setFieldsValue({ "currency": "" })
      }

      // setTableListForSortOriginal(old => filteredData)
      // setPagination({
      //   ...pagination,
      //   current: 1
      // })

    }
  }

  const columnsData = [
    {
      title: (
        <div className="flex"  style={{marginLeft:-16}} >
          <SortableColumn
         
            data={tableList}
            setData={setTableFilterList}
            dataOriginal={tableListForSortOriginal}
            type={"date"}
            parameter={"date"}
            hasTime={true}
          
          />
          <CustomTooltip
            className="table-tooltip"
            title={t("transfers.UploadDate")}
            placement="top"
          >
            {' '}
            <Form form={form}>
              <SelectField
                // open={true}
                // width={95}
                placeholder={t("transfers.UploadDate")}
                width={128}
                // options={dateFilter}
                options={dateList}
                className="ant-table-column-title"
                name={'date_filter'}
                // onChange={(value: string) => filterHandler(value, 'date')}

                onChange={(value: string) => handleFilterColumn(value, 'date')}
              />
            </Form>
          </CustomTooltip>
        </div>
      ),
      dataIndex: 'date',
      key: 'date',
      className: 'date',
      // sorter: (a, b) => moment(a.date, "DD.MM.YYYY").unix() - moment(b.date, "DD.MM.YYYY").unix(),
      render: (data) => (
        <>
          <p>{data}</p>
        </>
      ),
      ellipsis: true,
      width: 89,
      editable: false,
    },
    {
      title: (
        <div className="searchable-column" >
          <div className={searchable ? 'bordered flex' : 'flex'}>
            <SearchableColumn
              form={form}
              filter={'searchfilter'}
              title={t("transfers.BatchNumber")}
              name={'packageN'}
              buttonClicked={buttonClicked}
              onChange={(event: any) => handleFilterColumn(event, 'packageN')}
              allowClear
            />
          </div>
        </div>
      ),
      dataIndex: 'packageN',
      ellipsis: true,
      key: 'packageN',
      width: 130,
      editable: false,
      render: (text: string, record: any) => {

        return (

          <Tooltip className="transfers-tooltip" title={text} placement="top" >
            <Button
              type="ghost"
              className="transparent"
            />
            <p>{text}</p>
          </Tooltip>

        )
      }
    },
    {
      title: (
        <div className="searchable-column">
          <div className={searchable ? 'bordered flex' : 'flex'}>
            <SearchableColumn
              large
              form={form}
              filter={'searchfilter'}
              name={'packageName'}
              onChange={(event: any) => handleFilterColumn(event, 'packageName')}
              title={t("transfers.batchName")}
              allowClear
            />
          </div>
        </div>
      ),
      dataIndex: 'packageName',
      key: 'packageName',
      ellipsis: true,
      width: 180,
      editable: false,
      render: (text: string, record: any) => {

        return (

          <Tooltip className="transfers-tooltip" title={text} placement="top" >
            <Button
              type="ghost"
              className="transparent"
            />
            <p>{text}</p>
          </Tooltip>

        )
      }
    },
    {
      title: (
        <div className="searchable-column">
          <SearchableColumn
            form={form}
            filter={'searchfilter'}
            name={'transferType'}
            onChange={(event: any) => handleFilterColumn(event, 'transferType')}
            title={t("transfers.transferType")}
            allowClear
          />
        </div>
      ),
      dataIndex: 'transferType',
      ellipsis: true,
      key: 'transferType',
      width: 135,
      editable: false,
      // render: (text: string, record: any) => <p>{text}</p>,
      render: (text: any, record: any) => {
      
        //   let arr :any=[]
        //   let shownValue :any=''
        // text?.map((row)=>{

        //    if(row[0]!==undefined && row[0]!==null){ 
        //     let typeRender1 = typeRender(row[0]) +`(${row[1]})`
        //     shownValue +=  row[0] +`(${row[1]}) `
        //     arr+=`${typeRender1+' '}`
        //    }
        //  })

        return (

          <Tooltip className="table-tooltip"
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: record.transferType
              }}
            />
          }placement="top" >
          <Button
            type="ghost"
            className="transparent"
          />
          <p>{record.trnTypeStr}</p>
        </Tooltip>
        )
      }
    },
    {
      title: (
        //   <div className="searchable-column">
        //   <div className="flex" style={{marginLeft: 24}}>
        //     <SortableColumn />
        //       <p>Ümumi məbləğ</p>
        //   </div>
        // </div>
        <div className="flex" >
          <SortableColumn
            name={"amount_filter"}
            data={tableList}
            setData={setTableFilterList}
            dataOriginal={tableListForSortOriginal}
            type={"number"}
            parameter={"amount"}
            // paramater_second={"amount"}
          />
          {t("transfers.groupTransferAmount")}
        </div>
      ),
      dataIndex: 'amount',
      key: 'amount',
      ellipsis: true,
      width: 100,
      editable: false,
      // sorter: (a: any, b: any) => a.amount - b.amount,
    },
    {
      title: (
        <div className="flex">
          <div className="filterable-column">
            <Form form={form}>
              {t("home.currency")}
              <SelectField
                width={70}
                placeholder={t("common.all")}
                options={currencyFilter}
                name={"currency_filter"}
                // dropdownClassName=""
                // className="status-select filter-status-select"
                onChange={(value) => handleFilterColumn(value, 'currency')}
              />
            </Form>
          </div>
        </div>
      ),
      dataIndex: 'currency',
      key: 'currency',
      width: 85,
      ellipsis: true,
      editable: false,
    },
    {
      title: (
        <div
          className="filterable-column"
          style={{ left: 10, position: 'relative' }}
        >
          <Form form={form}>
            {t("transfers.batchStatus")}
            <SelectField
              // open={false}
              placeholder={t("common.all")}
              width={220}
              name={"status_filter"}
              options={statusfilter}
              // defaultActiveFirstOption={true}
              dropdownClassName="mass-status-select"
              // className="status-select filter-status-select"
              onChange={(value: String) => handleFilterColumn(value, 'status')}
          
            />
          </Form>
        </div>
      ),
      dataIndex: 'status',
      key: 'status',
      width: 160,
      minWidth: 125,
      ellipsis: true,
      render: (text: string, record: any) => {

        return (

          <TransferStatus
            statusValue={record?.status}
            statusType={record?.status}
          />
        )
      },
      editable: false,
    },
    {
      title: '',
      key: '',
      width: 50,
      ellipsis: true,
      dataIndex: '',
      render: (text, record) => {
        return (
          <a onClick={(e) => { onExpand(false, e, "tooltip") }}>
            <Popover
              // visible={true}

              placement="topRight"
              overlayClassName=""
              content={
                <div className='manage_faster_menus mass_info_modal swift_modal' style={{ width: 390 }} >
                  <table className={`table table-hover mass_info_modal swift_table form_next_table`}>
                    <tbody>
                      {
                        record.modalData?.map((line,index) => {
                          return (
                            <tr style={index !== 3 ?{borderBottom:'1px solid #D9E3EC'}: {}}>
                              <td style={{color:'#747A83'}}>{line.label}</td>
                              <td style={{textAlign:"right"}}>{line.value}</td>
                            </tr>
                          )
                        })
                      }

                    </tbody>
                  </table>
                </div>
              }
            >
              <Button
                className="transparent"
                style={{ width: '100%' }}
                icon={<TabsInfoIco />}
              />
            </Popover>
          </a>
        )
      },
    },
    // {
    //   title: '',
    //   width: 50,
    //   key: 'action',
    //   ellipsis: true,
    //   render: (text, record) => (
    //     <Dropdown
    //       overlay={tableDropDown}
    //       trigger={['click']}
    //       placement="topCenter"
    //       disabled={record.status !== "BATCH_CHECK_ERROR"}
    //     >
    //       <Button
    //         icon={<AccountMoreIco />}
    //         className="transparent table_more_btn"
    //       />
    //     </Dropdown>
    //   ),
    // },
  ]



  const getData = async (startDate, endDate, fromBranch, batchName, batchStatus, trn_type, statusOptions, menu) => {
    let trntype = []
    setApplyLoading(true)
    settableLoading(true)
    setCheckedList([])
    setpackageNumber([])
    const batch_status = statusOptions?.filter((row) => row.value === batchStatus)[0]?.code

    const data = await getBatchPaymentsData(language,startDate, endDate, fromBranch, batchName,trn_type, batch_status)
    let temp_dates = [{ label: t("common.all"), value: 'all' }];
    let temp_array = []
    let inner_data = []
    let uniqueCurrencies = new Set();
    data.packages?.map((row: any, index: any) => {
      const entries = Object.entries(row.trnTypeSummary)
      let arr: any = []
      let shownValue: any = ''
      entries?.map((row,num:any) => {

        if (row[0] !== undefined && row[0] !== null) {

          let typeRender1 = typeRender(row[0])+" "+ `(${row[1]})`
          shownValue += num!==entries.length-1 ? row[0] + `(${row[1]})` + ", " : row[0] + `(${row[1]}) `
          // arr += `${typeRender1 + ' '}`
          arr += num!==entries.length-1 ?  typeRender1 + "<br/>" : typeRender1
          
        }
      })
      let filter_date = moment(row.createDate).format("DD.MM.YYYY");

      let check_date = temp_dates.find(row => row.value == filter_date);

      if (!check_date) {
        temp_dates.push({ label: filter_date, value: filter_date })
      }

      uniqueCurrencies.add(row.ccyType);
      temp_array.push({
        key: row.packageNumber,
        date: moment(row.createDate).format("DD.MM.YYYY HH:mm"),
        packageN: row.packageNumber,
        packageName: row.batchName,
        transferType: arr,
        trnTypeStr: shownValue,
        amount: financial(row.totalAmount),
        currency: row.ccyType,
        status: row.batchStatus,
        trnListDTO: row.trnList,
        modalData: [
          {
            label: t("transfers.fromAccount"),
            value: row.CUSTACC,
          },
          {
            label: t("transfers.totalCommission"),
            value: financial(row.totalCommAmount) + " " + `${row.ccyType !== null ? row.ccyType : ''}`,
          }, {
            label: t("transfers.NumberOfTransfers"),
            value: row.trnList?.length,
          }, {
            label: t("transfers.batchUploadedBy"),
            value: row.createUser,
          }
        ],

      })
     row.trnList?.map((item,index1) =>{

       if(item.packageNumber === packageNumber) {
         inner_data.push({
           key: index1 + "/" + item.PMTID + "/" + item.packageNumber,
           code: item.BRTrnType,
           PMTID: item.PMTID,
           packageNumber: item.packageNumber,
           docNumber: item.PMTCUSTID,
           receiver: item.benefName,
           amount: financial(item.amount),
           currency: item.ccyType,
           assignment: item.description,
           status: item.trnStatus,
           inner: true,
           ibankref: item.ibankref,
           checkMessage: item.checkMessage,
           checkMessageDetails: item.checkMessageDetails,
           mainDetail: item.mainDetail,
           modalData: modalRenderBT(item),

         })
       }

     })
    })
    let temp_currency: any = [{ label: t("common.all"), value: 'all' }];
    let temp_status: any = [{ label: t("common.all"), value: 'all' }];
    data.packages?.map(item => {

      let check_currency = temp_currency.find(row => row.value == item.ccyType && item.ccyType !== undefined);

      if (!check_currency && item.ccyType !== null) {
        temp_currency.push({
          label: item.ccyType,
          value: item.ccyType
        })
      }
      let check_status = temp_status.find(row => row.value == item.batchStatus && item.batchStatus !== undefined);

      if (!check_status && item.batchStatus !== null) {
        temp_status.push({
          label: statusFilterDemo.find(row=>row.value=== item.batchStatus)?.label,
          code: statusFilterDemo.find(row=>row.value=== item.batchStatus)?.code,
          value: item.batchStatus
        })
      }

    });



    let tempData = JSON.parse(JSON.stringify(inner_data));
    setCurrencyFilter(temp_currency);
    setTableFilterList(temp_array)
    setInnerTableData(tempData)
    setDateList(temp_dates)
    setTableListForSortOriginal(temp_array)
    setApplyLoading(false)
    settableLoading(false)
    setStatusFilter(temp_status)
  }



  const getPayment = async (record: any,from:any) => {
    let data;
    setStatusLoading(true)
    settableLoading(true)

    if (record.packageN) {
      data = await getPaymentByPackageNumber(language,record.packageN)
    }
    else if (record?.packageNumber) {
      data = await getPaymentByPackageNumber(language,record?.packageNumber)
    } else {
      data = await getPaymentByPackageNumber(language,record)
    }
    let inner_data = []

    data?.trnList?.map((item, index) => {
      inner_data.push({
        key: index + "/" + item.PMTID + "/" + item.packageNumber,
        code: item.BRTrnType,
        PMTID: item.PMTID,
        packageNumber: item.packageNumber,
        docNumber: item.PMTCUSTID,
        receiver: item.benefName,
        amount: financial(item.amount),
        currency: item.ccyType,
        assignment: item.description,
        status: item.trnStatus,
        inner: true,
        ibankref: item.ibankref,
        checkMessage:item.checkMessage,
        checkMessageDetails:item.checkMessageDetails,
        mainDetail: item.mainDetail,
        modalData: modalRenderBT(item),

      })
    })
    // fetchData()
    const temp_array = tableList
    let result=[]
    if (record.packageN) {
      const findIndex = tableList.findIndex(row => row.packageN === record.packageN)
      temp_array[findIndex].status = data?.batchStatus
      temp_array[findIndex].trnListDTO = inner_data
       result.push({
        "packageNumber":record.packageN
      })
    }
    else if (record?.packageNumber) {
      const findIndex = tableList.findIndex(row => row.packageN === record.packageNumber)
      temp_array[findIndex].status = data?.batchStatus
      temp_array[findIndex].trnListDTO = inner_data
      result.push({
        "packageNumber":record.packageNumber
      })
    } else {
      const findIndex = tableList.findIndex(row => row.packageN === record)
      temp_array[findIndex].status = data?.batchStatus
      result.push({
        "packageNumber":record
      })
      temp_array[findIndex].trnListDTO = inner_data
    }



   if(from!=="deleteInner")
    { if(data?.batchStatus === 'BATCH_CHECK_WAITING' || data?.batchStatus === 'BATCH_CHECK_ERROR'){
      setChechkedTransfer(result)
      setpackageNumberForCheck(result)
      setCheckDisabled(false)
      setDisabledDelete(false)
    }
    if(data?.batchStatus === 'BATCH_WAITING_CREATE') {
      setPackageNumberForDelete(result)
      const resultForDelete =  tableList.filter((cert) => {
 
        if(cert.status === 'BATCH_WAITING_CREATE')
        {  let arr = result.filter((detail) => detail.packageNumber === cert.packageN )
          return !(arr.length === 0)
        }
      })
        console.log(resultForDelete)
      let lengthDelete =0
      resultForDelete?.map((r)=>{
        
        lengthDelete += r.trnListDTO?.length
      })
      console.log(lengthDelete)
      setDeletedTransfersLength(lengthDelete)
      setpackageNumber(result[0].packageNumber)
      setCreateDisabled(false)
      setDisabledDelete(false)
    }
  }

    const dataInner = inner_data.filter(row => row.status === 'BATCH_CHECK_ERROR' || row.status === 'BATCH_PAYMENTERROR')
    let tempData = JSON.parse(JSON.stringify(inner_data));
    
    setallinnerData(tempData)
    setInnerTableData(tempData)
    setTableFilterList(temp_array)
    setErroredData(dataInner)
   
    setStatusLoading(false)
    settableLoading(false)

  }



  const refreshInnerTable = (packageNumber) => {

    const tempList = tableList.filter(row => row.packageN === packageNumber)
  
    let inner_data = []

    tempList?.trnListDTO?.map((item, index) => {
      inner_data.push({
        key: index + "/" + item.PMTID + "/" + item.packageNumber,
        code: item.BRTrnType,
        PMTID: item.PMTID,
        packageNumber: item.packageNumber,
        docNumber: item.PMTCUSTID,
        receiver: item.benefName,
        amount: financial(item.amount),
        currency: item.ccyType,
        assignment: item.description,
        status: item.trnStatus,
        inner: true,
        ibankref: item.ibankref,
        checkMessage:item.checkMessage,
        checkMessageDetails:item.checkMessageDetails,
        mainDetail: item.mainDetail,
        modalData: modalRenderBT(item),

      })
    })
    const dataInner = inner_data.filter(row => row.status === 'BATCH_CHECK_ERROR' || row.status === 'BATCH_PAYMENTERROR')
    setErroredData(dataInner)
    let tempData = JSON.parse(JSON.stringify(inner_data));
    
    setallinnerData(tempData)
    setInnerTableData(tempData)


  }


  const handleReset = (args: string) => {

    if (args === 'reset') {
      form.resetFields()
    }
    setCheckedList([])

  }


  const onRow = (item: any) => {
    const isExpanded = expandedKeys.includes(item.key);

    expandedKeys.includes(item.key) && { className: 'expand-parent' }
    onExpand(!isExpanded, item)
    // setTimeout(()=>{
    //
    // },2000)
  }


  const onCell = (item) => {

    const isExpanded = expandedKeys.includes(item.key);

  }

  const modalRenderBT = (detailDataState: any) => {

    switch (detailDataState.BRTrnType || detailDataState.code ) {
      case 'IM':
        return modalDataTransfersIM_BT(detailDataState)
      case 'IT':
        return modalDataTransfersIT_BT(detailDataState)
      case 'AZ':
        return modalDataTransfersAZIPSXOHKS_BT(detailDataState)
      case  'XO':
        return modalDataTransfersAZIPSXOHKS_BT(detailDataState)
      case 'XT':
        return modalDataTransfersDXA_BT(detailDataState)
      case 'XV':
        return modalDataTransfersXV_BT(detailDataState)
      default:
        return null
    }
  }

  const modalDataTransfersIM_BT = (item: any) => {

    return [
      {
        label: i18next.t("modal.modalType"),
        value: item.BRTrnType
      },
      {
        label: i18next.t("transfers.transferType"),
        value: typeRender(item.BRTrnType)
      },
      {
        label: i18next.t("salary.documentNo"),
        value:  item.PMTCUSTID ? item.PMTCUSTID : '',
        code: 'PMTCUSTID'
      },
      {
        label: i18next.t("transfers.fromAccount"),
        value: (item.nickName ?? item.CUSTACC) + " " + `${item.ccyType!== undefined ? item.ccyType :''}`,
        code: "CUSTACC"
      },
      {
        label: i18next.t("common.amount"),
        value: item.amount !== undefined && financial(item.amount) !==undefined? financial(item.amount)+" " + `${item.ccyType!== undefined ? item.ccyType :''}`:"",
        code:"amount"
      },
      {
        label: i18next.t("transfers.beneficiarAccount"),
        value: item.benefAcc,
        code:"benefAcc"
      },
      {
        label: i18next.t("newTransfer.beneficiaryName"),
        value: item.benefName,
        code:'benefName'
      },
      {
        label: i18next.t("home.commission"),
        value: financial(item.commAmount)+" " +  `${item.ccyType!== undefined ? item.ccyType :''}`,
        code:'commAmount'
      },
      {
        label: i18next.t("home.paymentDetailsBT"),
        value: item.description?.replace(item.mainDetail,''),
        code:"description"
      },
      {
        label: i18next.t("newTransfer.note"),
        value: item.note,
        code:"note"
      },
      {
        label:'Status',
        value: renderTextforBatch(item.trnStatus)
      },{
        label:t("transfers.createDateintransfers"),
        value: moment(item.paymentDate).format("DD.MM.YYYY HH:mm") !== "Invalid date" ? moment(item.paymentDate).format("DD.MM.YYYY HH:mm") : ""
      },{
        label:t("transfers.createdbyWhoTransfers"),
        value: item.paymentUser
      }
    ];
  }

  const modalDataTransfersIT_BT = (item: any) => {

    return [
      {
        label: i18next.t("modal.modalType"),
        value: item.BRTrnType
      },
      {
        label: i18next.t("transfers.transferType"),
        value: typeRender(item.BRTrnType)
      },
      {
        label: i18next.t("salary.documentNo"),
        value:  item.PMTCUSTID ? item.PMTCUSTID : '',
        code: 'PMTCUSTID'
      },
      {
        label: i18next.t("transfers.fromAccount"),
        value: (item.nickName ?? item.CUSTACC) + " " + `${item.ccyType!== undefined ? item.ccyType :''}`,
        code: "CUSTACC"
      },
      {
        label: i18next.t("common.amount"),
        value:item.amount !== undefined && financial(item.amount) !==undefined? financial(item.amount)+" " + `${item.ccyType!== undefined ? item.ccyType :''}`:"",
        code:"amount"
      },
      {
        label: i18next.t("transfers.beneficiarAccount"),
        value: item.benefAcc,
        code:"benefAcc"
      },
      {
        label: i18next.t("newTransfer.beneficiaryName"),
        value: item.benefName,
        code:'benefName'
      },
      {
        label: i18next.t("home.commission"),
        value: financial(item.commAmount) + " " +  `${item.ccyType!== undefined ? item.ccyType :''}`,
        code:'commAmount'
      },
      {
        label: i18next.t("accountStatement.mainPayment"),
        value: item.mainDetail,
        code:"mainDetail"
      },
      {
        label: i18next.t("home.paymentDetailsBT"),
        value: item.description?.replace(item.mainDetail,''),
        code:"description"
      },
      {
        label: i18next.t("newTransfer.note"),
        value: item.note,
        code:"note"
      },
      {
        label:'Status',
        value: renderTextforBatch(item.trnStatus)
      },{
        label:t("transfers.createDateintransfers"),
        value: moment(item.paymentDate).format("DD.MM.YYYY HH:mm") !== "Invalid date" ? moment(item.paymentDate).format("DD.MM.YYYY HH:mm") : ""
      },{
        label:t("transfers.createdbyWhoTransfers"),
        value: item.paymentUser
      }
    ];
  }

  const modalDataTransfersAZIPSXOHKS_BT = (item: any) => {
    return [
      {
        label: i18next.t("modal.modalType"),
        value: item.BRTrnType
      },
      {
        label: i18next.t("transfers.transferType"),
        value: typeRender(item.BRTrnType)
      },
      {
        label: i18next.t("salary.documentNo"),
        value:  item.PMTCUSTID ? item.PMTCUSTID : '',
        code: 'PMTCUSTID'
      },
      {
        label: i18next.t("transfers.fromAccount"),
        value: (item.nickName ?? item.CUSTACC) + " " + `${item.ccyType!== undefined ? item.ccyType :''}`,
        code: "CUSTACC"
      },
      {
        label: i18next.t("newTransfer.beneficiaryName"),
        value: item.benefName,
        code:'benefName'
      },
      {
        label: i18next.t("transfers.beneficiarAccount"),
        value: item.benefAcc,
        code:"benefAcc"
      },
      {
        label: i18next.t("transfers.beneficiarTax"),
        value: item.benefTIN,
        code:"benefTIN"
      },
      {
        label: i18next.t("requisites.benefisiarBankCode"),
        value: item.benefBankCode,
        code:"benefBankCode"
      },
      {
        label: i18next.t("requisites.benefisiarBankName"),
        value: item.benefBankName,
        code:"benefBankName"
      },
      {
        label: i18next.t("common.amount"),
        value: item.amount !== undefined && financial(item.amount) !==undefined? financial(item.amount)+" " + `${item.ccyType!== undefined ? item.ccyType :''}`:"",
        code:"amount"
      },

      {
        label: i18next.t("home.commission"),
        value: financial(item.commAmount) + " " +  `${item.ccyType!== undefined ? item.ccyType :''}`,
        code:'commAmount'
      },
      {
        label: i18next.t("accountStatement.mainPayment"),
        value: item.mainDetail,
        code:"mainDetail"
      },
      {
        label: i18next.t("home.paymentDetailsBT"),
        value: item.description?.replace(item.mainDetail,''),
        code:"description"
      },
      {
        label: i18next.t("transfers.infoForBeneficiary"),
        value: item.infoToBenef,
        code:"infoToBenef"
      },
      {
        label: i18next.t("newTransfer.note"),
        value: item.note,
        code:"note"
      },
      {
        label:'Status',
        value: renderTextforBatch(item.trnStatus)
      },{
        label:t("transfers.createDateintransfers"),
        value: moment(item.paymentDate).format("DD.MM.YYYY HH:mm") !== "Invalid date" ? moment(item.paymentDate).format("DD.MM.YYYY HH:mm") : ""
      },{
        label:t("transfers.createdbyWhoTransfers"),
        value: item.paymentUser
      }
    ];
  }

  const modalDataTransfersDXA_BT = (item: any) => {
    return [
      {
        label: i18next.t("modal.modalType"),
        value: item.BRTrnType
      },
      {
        label: i18next.t("transfers.transferType"),
        value: typeRender(item.BRTrnType)
      },
      {
        label: i18next.t("salary.documentNo"),
        value:  item.PMTCUSTID ? item.PMTCUSTID : '',
        code: 'PMTCUSTID'
      },
      {
        label: i18next.t("transfers.fromAccount"),
        value: (item.nickName ?? item.CUSTACC) + " " + `${item.ccyType!== undefined ? item.ccyType :''}`,
        code: "CUSTACC"
      },
      {
        label: i18next.t("newTransfer.beneficiaryName"),
        value: item.benefName,
        code:'benefName'
      },
      {
        label: i18next.t("transfers.beneficiarAccount"),
        value: item.benefAcc,
        code:"benefAcc"
      },
      {
        label: i18next.t("transfers.beneficiarTax"),
        value: item.benefTIN,
        code:"benefTIN"
      },
      {
        label: i18next.t("requisites.benefisiarBankCode"),
        value: item.benefBankCode,
        code:"benefBankCode"
      },
      {
        label: i18next.t("requisites.benefisiarBankName"),
        value: item.benefBankName,
        code:"benefBankName"
      },
      {
        label: i18next.t("newTransfer.budgetClassificationCodes"),
        value: item.dxaClassCode,
        code:'dxaClassCode'
      },
      {
        label: i18next.t("newTransfer.budgetLevelCode"),
        value: item.BUDGETLEVELCODENAME,
        code:'dxaOrgCode'
      },
      {
        label: i18next.t("common.amount"),
        value: item.amount !== undefined && financial(item.amount) !==undefined ? financial(item.amount)+" " + `${item.ccyType!== undefined ? item.ccyType :''}`:"",
        code:"amount"
      },
      {
        label: i18next.t("home.commission"),
        value: financial(item.commAmount) + " " +  `${item.ccyType!== undefined ? item.ccyType :''}`,
        code:'commAmount'
      },
      {
        label: i18next.t("home.paymentDetailsBT"),
        value: item.description?.replace(item.mainDetail,''),
        code:"description"
      },
      {
        label: i18next.t("transfers.infoForBeneficiary"),
        value: item.infoToBenef,
        code:"infoToBenef"
      },
      {
        label: i18next.t("newTransfer.note"),
        value: item.note,
        code:"note"
      },
      {
        label:'Status',
        value: renderTextforBatch(item.trnStatus)
      },{
        label:t("transfers.createDateintransfers"),
        value: moment(item.paymentDate).format("DD.MM.YYYY HH:mm") !== "Invalid date" ? moment(item.paymentDate).format("DD.MM.YYYY HH:mm") : ""
      },{
        label:t("transfers.createdbyWhoTransfers"),
        value: item.paymentUser
      }
    ];
  }

  const modalDataTransfersXV_BT = (item: any) => {
    return [
      {
        label: i18next.t("modal.modalType"),
        value: item.BRTrnType
      },
      {
        label: i18next.t("transfers.transferType"),
        value: typeRender(item.BRTrnType)
      },
      {
        label: i18next.t("salary.documentNo"),
        value:  item.PMTCUSTID ? item.PMTCUSTID : '',
        code: 'PMTCUSTID'
      },
      {
        label: i18next.t("transfers.fromAccount"),
        value: (item.nickName ?? item.CUSTACC) + " " + `${item.ccyType!== undefined ? item.ccyType :''}`,
        code: "CUSTACC"
      },
      {
        label: i18next.t("newTransfer.beneficiaryName"),
        value: item.benefName,
        code:'benefName'
      },
      {
        label: i18next.t("transfers.beneficiarAccount"),
        value: item.benefAcc,
        code:"benefAcc"
      },
      {
        label: i18next.t("transfers.beneficiarTax"),
        value: item.benefTIN,
        code:"benefTIN"
      },
      {
        label: i18next.t("requisites.benefisiarBankCode"),
        value: item.benefBankCode,
        code:"benefBankCode"
      },
      {
        label: i18next.t("requisites.benefisiarBankName"),
        value: item.benefBankName,
        code:"benefBankName"
      },
      {
        label: i18next.t("common.amount"),
        value:item.amount !== undefined && financial(item.amount) !== undefined? financial(item.amount)+" " + `${item.ccyType!== undefined ? item.ccyType :''}`:"",
        code:"amount"
      },

      {
        label: i18next.t("home.commission"),
        value: financial(item.commAmount) + " " +  `${item.ccyType!== undefined ? item.ccyType :''}`,
        code:'commAmount'
      },
      {
        label: i18next.t("home.paymentDetailsBT"),
        value: item.description?.replace(item.mainDetail,''),
        code:"description"
      },
      {
        label: i18next.t("transfers.infoForBeneficiary"),
        value: item.infoToBenef,
        code:"infoToBenef"
      },
      {
        label: i18next.t("newTransfer.note"),
        value: item.note,
        code:"note"
      },
      {
        label:'Status',
        value: renderTextforBatch(item.trnStatus)
      },{
        label:t("transfers.createDateintransfers"),
        value: moment(item.paymentDate).format("DD.MM.YYYY HH:mm") !== "Invalid date" ? moment(item.paymentDate).format("DD.MM.YYYY HH:mm") : ""
      },{
        label:t("transfers.createdbyWhoTransfers"),
        value: item.paymentUser
      }
    ];
  }

  const onExpand = (expanded, { key }, type) => {


    if(type !== "tooltip" && !boolTooltip) {

      let inner_data = []
      tableList.filter((row) => row.key === key).map((pack) => {
        setPackageStatus(pack.status)
        pack.trnListDTO?.map((item, index) => {

          if (item.inner) {

            inner_data.push({
              key: item.key,
              code: item.code,
              PMTID: item.PMTID,
              docNumber: item.docNumber,
              packageNumber: item.packageNumber,
              receiver: item.receiver,
              amount: financial(item.amount),
              currency: item.currency,
              assignment: item.assignment,
              status: item.status,
              inner: item.inner,
              ibankref: item.ibankref,
              checkMessage: item.checkMessage,
              checkMessageDetails: item.checkMessageDetails,
              mainDetail: item.mainDetail,
              modalData: item.modalData,

            })
          } else {


            inner_data.push({
              key: index + "/" + item.PMTID + "/" + item.packageNumber,
              code: item.BRTrnType,
              PMTID: item.PMTID,
              docNumber: item.PMTCUSTID,
              packageNumber: item.packageNumber,
              receiver: item.benefName,
              amount: financial(item.amount),
              currency: item.ccyType,
              assignment: item.description,
              status: item.trnStatus,
              inner: true,
              checkMessage: item.checkMessage,
              checkMessageDetails: item.checkMessageDetails,
              ibankref: item.ibankref,
              mainDetail: item.mainDetail,
              modalData: modalRenderBT(item),

            })
          }

        })
      })
      let tempData = JSON.parse(JSON.stringify(inner_data));

      setallinnerData(tempData)
      setInnerTableData(tempData)

      const data = inner_data.filter(row => row.status === 'BATCH_CHECK_ERROR' || row.status === 'BATCH_PAYMENTERROR')

      setErroredData(data)

      const keys: any = []
      let expandedKeysData


      if (expanded) {
        keys.push(key)
        expandedKeysData = keys
      } else {
        expandedKeysData = []
      }

      setExpandedKeys(expandedKeysData)
    } else {

      setClickedFromTooltip(true)
      boolTooltip = !boolTooltip;
      // setExpandedKeys([])
    }


  }


  function onSelectChange(checkedList: Array<String>) {

    const temp_list: any = [];
    const innerTempArr: any = []

    if (checkedList.length === 0) {
      setCreateDisabled(true)
      setDisabledDelete(true)
      setDisabledXLS(true)
    }

    const array: any = []
    const arrayIbank: any = []
    checkedList.forEach(element1 => {

      var findElement: any = tableList.find((cert: any) => cert.key === element1)
      if (findElement !== null && findElement !== undefined) {
        if(findElement.status !== 'BATCH_CHECK_START' && findElement.status !== "BATCH_START_CREATE" ) setDisabledXLS(false)

        array.push(findElement)
          if(findElement.status === "BATCH_CHECK_WAITING" || findElement.status === 'BATCH_CHECK_ERROR'|| findElement.status === 'BATCH_WAITING_CREATE' || findElement.status === 'BATCH_PAYMENTERROR'){
            setDisabledDelete(false)

          }else{
            setDisabledDelete(true)
          }



         if(array.filter((cert) => cert.status === 'BATCH_FORPAYMENT' ).length > 0){
           setDisabledDelete(true)
           setCheckDisabled(true)
         }else{
           setCheckDisabled(false)
         }
         if(array.filter((cert) => cert.status === 'BATCH_FORPAYMENT' || cert.status === 'BATCH_WAITING_CREATE').length > 0){
          
          setCheckDisabled(true)
        }else{
          setCheckDisabled(false)
        }

        if(findElement.status === "BATCH_CHECK_WAITING" || findElement.status === 'BATCH_CHECK_ERROR'|| findElement.status === 'BATCH_WAITING_CREATE'|| findElement.status === 'BATCH_PAYMENTERROR' || findElement.status === 'BATCH_FORPAYMENT' )  {
          findElement?.trnListDTO?.map((row)=>{
           
            if(row.ibankref!==null){
              arrayIbank.push({
                  ibankRef: row.ibankref
                })

                 setdisablePDF(false)
            }else{
              setdisablePDF(true)
            }
                
          })
        
        }else{
          setdisablePDF(true)

        }
        if(array.filter((cert) => cert.status !== 'BATCH_FORPAYMENT').length > 0) {
          setdisablePDF(true)
        }
        if (findElement.status === "BATCH_WAITING_CREATE" || findElement.status === 'BATCH_PAYMENTERROR') {
          const data = array?.filter((item) => item.status !== "BATCH_WAITING_CREATE" && findElement.status !== 'BATCH_PAYMENTERROR')

          if (data.length > 0) {
            setCreateDisabled(true)
          } else {
            setCreateDisabled(false)
          }
        } else {
          setCreateDisabled(true)
        }
        var i = 0;
        findElement?.trnListDTO.forEach(element => {
          temp_list.push(i + "/" + element.PMTID + "/" + element.packageNumber)
          i++;

        });
        temp_list.push(element1);
      } else {
        setDisabledXLS(true)
        setCreateDisabled(true)
        temp_list.push(element1);

        const innerCheckList = element1.split("/")
        const checkedParentList = tableList.find(row => row.packageN === innerCheckList[2])

        if (checkedParentList !== undefined && checkedParentList !== null) {
          const checkedInnerList = checkedParentList?.trnListDTO?.find(row => row.PMTID === innerCheckList[1])
         
            if( checkedInnerList.trnStatus === 'BATCH_CHECK_WAITING' || checkedInnerList.status === 'BATCH_CHECK_WAITING'||
              checkedInnerList.trnStatus === "BATCH_CHECK_ERROR" || checkedInnerList.status === "BATCH_CHECK_ERROR" ||
              checkedInnerList.trnStatus === "BATCH_WAITING_CREATE" || checkedInnerList.status === "BATCH_WAITING_CREATE" ||
               checkedInnerList.trnStatus === "BATCH_PAYMENTERROR" || checkedInnerList.status === "BATCH_PAYMENTERROR" ){
                setDisabledDelete(false)
               }else{
                setDisabledDelete(true)
               }
          if (checkedInnerList.ibankref !== null && checkedInnerList.ibankref !== undefined) {
            arrayIbank.push({
              ibankRef: checkedInnerList.ibankref
            })
          
            if(checkedInnerList.trnStatus?.includes('BATCH') || checkedInnerList.status?.includes('BATCH')  || checkedInnerList.trnStatus === 'EXPIRED' || checkedInnerList.status === 'EXPIRED'||checkedInnerList.trnStatus === "DELETED" || checkedInnerList.status === "DELETED" )
            {
              setdisablePDF(true)
            }else{
               setdisablePDF(false)
            }
     

          } else {
            setdisablePDF(true)
          }
        }
      }

      var i = 0;
      temp_list.map((item: any) => {
        const innerCheckList = item.split("/")

        const checkInner = innerTempArr.find(row => row.PMTID === innerCheckList[1])
        if (!checkInner) {
          innerTempArr.push({
            "PMTID": innerCheckList[1]
          })

        }
        
        setpackageNumberInner(innerCheckList[2])
       
        var findElement: any = tableList.find((cert: any) => cert.key === innerCheckList[2])
    
        i++;

        if (i === findElement?.trnListDTO.length) {
          if(findElement.status === 'BATCH_WAITING_CREATE'|| findElement.status === "BATCH_PAYMENTERROR"){
            setCreateDisabled(false)
          }else{
            setCreateDisabled(true)
          }
          var findElement1: any = temp_list.find((cert1: any) => cert1 === innerCheckList[2])

          if (findElement1 === null || findElement1 === undefined) {

            temp_list.push(innerCheckList[2])
          }
        }
      })

    });

    setSinglePdf(arrayIbank)
    setInnerCheckList(innerTempArr)

    setCheckedList(temp_list);


    if (temp_list.length === 0) {
      setdisablePDF(true)
    }
    const result = tableList.filter((cert) => {

      if(cert.status === 'BATCH_CHECK_WAITING'||cert.status === 'BATCH_WAITING_CREATE' || cert.status ==='BATCH_CHECK_ERROR'  || cert.status === 'BATCH_PAYMENTERROR')
      {  let arr = temp_list.filter((detail) => detail === cert.packageN )
        return !(arr.length === 0)
      }
    })
console.log(result)
    let temp_check_array: any = []
    let arrayfordelete :any = []
    const resultForDelete =  tableList.filter((cert) => {
 
      if(cert.status === "BATCH_CHECK_WAITING" || cert.status === 'BATCH_CHECK_ERROR'|| cert.status === 'BATCH_WAITING_CREATE'|| cert.status === 'BATCH_PAYMENTERROR')
      {  let arr = temp_list.filter((detail) => detail === cert.packageN )
        return !(arr.length === 0)
      }
    })
    let lengthDelete =0
    resultForDelete?.map((r)=>{
      arrayfordelete.push({
        "packageNumber": r.packageN
      })
      lengthDelete += r.trnListDTO?.length
    })


    const resultForcreateXls =  tableList.filter((cert) => {

      if(cert.status === 'BATCH_WAITING_CREATE'  || cert.status !== 'BATCH_PAYMENTERROR')
      {  let arr = temp_list.filter((detail) => detail === cert.packageN )
        return !(arr.length === 0)
      }
    })
    const resultForCreate =  tableList.filter((cert) => {

      if(cert.status === 'BATCH_WAITING_CREATE' )
      {  let arr = temp_list.filter((detail) => detail === cert.packageN )
        return !(arr.length === 0)
      }
    })
    const resultForLength = tableList.filter((cert) => {
      let arr = temp_list.filter((detail) => detail === cert.packageN )
      return !(arr.length === 0)
    })

    if(resultForLength.length > 1){
      setCreateDisabled(true)
      setdisablePDF(true)
    }else if(resultForCreate.length === 1){
      setCreateDisabled(false)
    }
    result?.map((item: any) => {
      temp_check_array.push(
        { "packageNumber": item.packageN })

    }
    )
    setDeletedTransfersLength(lengthDelete)
    setPackageNumberForDelete(arrayfordelete)
    setpackageNumberForCheck(temp_check_array)
    setChechkedTransfer(result)
    let temp_array: any = []
    resultForcreateXls?.map((item: any) => {
      temp_array = item.packageN

    })

    if(resultForcreateXls.length>1 || resultForcreateXls.filter((cert) => cert.status === 'BATCH_CHECK_START' ||  cert.status === 'BATCH_START_CREATE' ).length !== 0){
      setDisabledXLS(true)
    }else if (resultForcreateXls.length === 1){
      setDisabledXLS(false)
    }
    setpackageNumber(temp_array)

  }


  const rowSelection = {
    selectedRowKeys,
    hideSelectAllCheckbox: true,
    columnWidth: 34,
    columnTitle: (
      <span style={{ marginLeft: 30 }}>
        <CustomTooltip className="transfers-tooltip" title={headerInfo}>
          <Button
            type="ghost"
            className="transparent"
            style={{ position: 'relative', margin: 'auto', bottom: '8px' }}
            icon={<TabsInfoIco />}
          />
        </CustomTooltip>
      </span>
    ),
    onChange: onSelectChange,

  }

  const rowSelectionInner = {
    selectedRowKeys,
    hideSelectAllCheckbox: true,
    columnWidth: 34,
    columnTitle: (
      
       
        <div></div>
      
     
    ),
    onChange: onSelectChange,

  }

  function downloadPDF(fileName: string, fileBase64: string) {
    const linkSource = `data:$application/download;base64,${fileBase64}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }


  const handleGetPdfMultiple = async (e) => {
    setLoadingPdf(true)
    let postData = { fileDetailsList: singlePdf }
    const data = await getPaymentOrderPdfByIbanRefMultiple(postData, e)
    let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
    pdfresult?.map((item: any) => {
      return downloadPDF(item.fileName, item.fileBase64)
    })
    setLoadingPdf(false)
  }


  const handleGetPdfSingle = async (selectLang: any, selectedRow: any,) => {
    setLoadingPdf(true)
    setLoadingPdfinner(true)

    if (singlePdf !== null && singlePdf !== undefined && singlePdf.length !== 0 && singlePdf.find((c)=>c.ibankRef === null) === undefined) {

      let postData = { fileDetailsList: singlePdf }
      let data;
      
      if (selectLang === "AZ" || selectLang === "EN" || selectLang === "RU") {
        data = await getPaymentOrderPdfByIbanRef(postData, selectLang)
      }

      let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
      pdfresult?.map((item: any) => {
        return downloadPDF(item.fileName, item.fileBase64)
      })
    } else {

      if(selectedRow !== undefined)
        {
          let singlepdfinner = [{
            ibankRef: selectedRow
          }]
          let postData = { fileDetailsList: singlepdfinner }
        
          let data;
          if (selectLang === "AZ" || selectLang === "EN" || selectLang === "RU") {
            data = await getPaymentOrderPdfByIbanRef(postData, selectLang)
          }

          let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
          pdfresult?.map((item: any) => {
            return downloadPDF(item.fileName, item.fileBase64)
          })
        }
    }
    setLoadingPdf(false)
    setLoadingPdfinner(false)
  }


  const handleGetPdfSingleInner = async (selectLang: any, selectedRow: any,) => {
    setLoadingPdfinner(true)
  
    if (singlePdf !== null && singlePdf !== undefined && singlePdf.length !== 0) {
      let postData = { fileDetailsList: singlePdf }
      let data;
      if (selectLang === "AZ" || selectLang === "EN" || selectLang === "RU") {
        data = await getPaymentOrderPdfByIbanRef(postData, selectLang)
      }

      let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
      pdfresult?.map((item: any) => {
        return downloadPDF(item.fileName, item.fileBase64)
      })
    } else {
      let singlepdfinner = [{
        ibankRef: selectedRow
      }]
      let postData = { fileDetailsList: singlepdfinner }
     
      let data;
      if (selectLang === "AZ" || selectLang === "EN" || selectLang === "RU") {
        data = await getPaymentOrderPdfByIbanRef(postData, selectLang)
      }

      let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
      pdfresult?.map((item: any) => {
        return downloadPDF(item.fileName, item.fileBase64)
      })
    }
    setLoadingPdfinner(false)
  }

  const handleGetExcelPackage = async (selectLang:any) =>{
    setloadingExcel(true)
    const data = await getBatchExcel(packageNumber,selectLang)
    data?.data.fileDetailsList.map(function (item, i) {
      const linkSource = `data:${item.mimeType};base64,${item.fileBase64}`
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = item.fileName
      downloadLink.click()
    })
    setloadingExcel(false)

  }


  const onOkCreateTransfer =async (tableDataXls: any, fromBranch: any, packageName: any, fileContent: any,type:any) => {


    let temp_array:any = [];
    setpackModalVisible(true)
    setButtonLoading(true)
    tableDataXls.map((row:any) => {
      if(type === 'text/csv'){
        if (row[1]==='IM'){
          temp_array.push(...tempArray, {
            "BRTrnType": row[1],
            "benefName": "",
            // "benefName": row.__EMPTY_4,
            "PMTCUSTID": row[2] !== null && row[2] !== undefined  ? "#"+row[2] : '',
            "benefAcc": row[4],
            "benefTIN": "",
            "benefBankCode": null,
            "dxaClassCode": null,
            "dxaOrgCode": null,
            "infoToBenef": "",
            "mainDetail": "",
            // "mainDetail": row.__EMPTY_11,
            "amount": (row[9] !== undefined && row[9] !== null && row[9] !== '' ? row[9] : "").toString(),
            "description": row[11] !== undefined && row[11] !== null && row[11] !== '' ? row[11] : "",
            "note": row[13] !== null ? row[13]  : ''
          })
        }else if (row[1] === "IT") {
          temp_array.push(...tempArray, {
            "BRTrnType": row[1],
            "benefName": "",
            // "benefName": row.__EMPTY_4,
            "PMTCUSTID": row[2] !== null && row[2] !== undefined ? "#"+ row[2] : '',
            "benefAcc": row[4],
            "benefTIN": "",
            "benefBankCode": null,
            "dxaClassCode": null,
            "dxaOrgCode": null,
            "infoToBenef": "",
            "mainDetail": 
            // row[5] !== undefined && row[5] !== null && row[5] !== '' ? "" : 
            row[10],
            "amount": (row[9] !== undefined && row[9] !== null && row[9] !== '' ? row[9] : "").toString(),
            "description": row[10] !== undefined && row[10] !== null && row[10] !== '' ? (row[5]!== undefined && row[5] !== null && row[5] !== '' ? (row[11] !== undefined && row[11]  !== null && row[11]  !== '' ? row[11] : "") : row[10]  + " " + (row[11]  !== undefined && row[11]  !== null && row[11] !== '' ? row[11] : "")) : (row[11]  !== undefined && row[11]  !== null && row[11]  !== '' ? row[11]  : ""),
            "note": row[14] !== null ? row[14] : ''
          })
        } else if (row[1] === "AZ" || row[1] === "XO") {
          temp_array.push(...tempArray, {
            "BRTrnType": row[1],
            "benefName": row[3],
            "PMTCUSTID": row[2] !== null && row[2] !== undefined ? "#"+ row[2] : '',
            "benefAcc": row[4],
            "benefTIN": row[5] !== null ? row[5] : '',
            "benefBankCode": row[6],
            "dxaClassCode": null,
            "dxaOrgCode": null,
            "infoToBenef": row[12] !== null ? row[12] : '',
            "mainDetail": row[5] !== undefined && row[5] !== null && row[5] !== '' ? "" : row[10],
            "amount": (row[9] !== undefined && row[9] !== null && row[9] !== '' ? row[9]  : "").toString(),
            "description": row[10] !== undefined && row[10] !== null && row[10] !== '' ? (row[5]!== undefined && row[5] !== null && row[5] !== '' ? (row[11] !== undefined && row[11]  !== null && row[11]  !== '' ? row[11] : "") : row[10]  + " " + (row[11]  !== undefined && row[11]  !== null && row[11] !== '' ? row[11] : "")) : (row[11]  !== undefined && row[11]  !== null && row[11]  !== '' ? row[11]  : ""),
            "note": row[13] !== null ? row[13] : ''
          })
        }else if (row[1] === "XT") {
          temp_array.push(...tempArray, {
            "BRTrnType": row[1],
            "benefName": '',
            "PMTCUSTID": row[2] !== null && row[2] !== undefined ? "#"+ row[2] : '',
            "benefAcc": row[4],
            "benefTIN": "",
            // "benefTIN": row.__EMPTY_6 !== null ? row.__EMPTY_6 : '',
            "benefBankCode": '',
            "dxaClassCode": row[7],
            "dxaOrgCode": row[8],
            "infoToBenef":  row[12] !== null ? row[12] : '',
            "mainDetail": "",
            // "mainDetail": row.__EMPTY_11,
            "amount": (row[9] !== undefined && row[9] !== null && row[9] !== '' ? row[9]  : "").toString(),
            "description": row[11] !== undefined && row[11] !== null && row[11] !== '' ? row[11] : "",
            "note": row[13] !== null ? row[13] : ''
          })
        } else if (row[1] === "XV") {
          temp_array.push(...tempArray, {
            "BRTrnType": row[1],
            "benefName": row[3],
            "PMTCUSTID": row[2] !== null && row[2] !== undefined ? "#"+ row[2] : '',
            "benefAcc": "",
            "benefTIN": row[5] !== null ? row[5] : '',
            "benefBankCode": '',
            "dxaClassCode": "",
            "dxaOrgCode": "",
            "infoToBenef": row[12] !== null ? row[12] : '',
            "mainDetail": "",
            // "mainDetail": row.__EMPTY_11,
            "amount": (row[9] !== undefined && row[9] !== null && row[9] !== '' ? row[9] : "").toString(),
            "description": row[11] !== undefined && row[11] !== null && row[11] !== '' ? row[11] : "",
            "note": row[13] !== null ? row[13] : ''
          })
        }
      }else{
        if (row.__EMPTY_1 === 'IM') {
        temp_array.push(...tempArray, {
          "BRTrnType": row.__EMPTY_1,
          "benefName": "",
          // "benefName": row.__EMPTY_4,
          "PMTCUSTID": row.__EMPTY_3 !== null && row.__EMPTY_3 !== undefined  ? "#"+row.__EMPTY_3 : '',
          "benefAcc": row.__EMPTY_5,
          "benefTIN": "",
          "benefBankCode": null,
          "dxaClassCode": null,
          "dxaOrgCode": null,
          "infoToBenef": "",
          "mainDetail": "",
          // "mainDetail": row.__EMPTY_11,
          "amount": (row.__EMPTY_10 !== undefined && row.__EMPTY_10 !== null && row.__EMPTY_10 !== '' ? row.__EMPTY_10 : "").toString(),
          "description": row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "",
          "note": row.__EMPTY_14 !== null ? row.__EMPTY_14 : ''
        })
      } else if (row.__EMPTY_1 === "IT") {
        temp_array.push(...tempArray, {
          "BRTrnType": row.__EMPTY_1,
          "benefName": "",
          // "benefName": row.__EMPTY_4,
          "PMTCUSTID": row.__EMPTY_3 !== null && row.__EMPTY_3 !== undefined ? "#"+row.__EMPTY_3 : '',
          "benefAcc": row.__EMPTY_5,
          "benefTIN": "",
          "benefBankCode": null,
          "dxaClassCode": null,
          "dxaOrgCode": null,
          "infoToBenef": "",
          "mainDetail": 
          // row.__EMPTY_6 !== undefined && row.__EMPTY_6 !== null && row.__EMPTY_6 !== '' ? "" : 
          row.__EMPTY_11,
          "amount": (row.__EMPTY_10 !== undefined && row.__EMPTY_10 !== null && row.__EMPTY_10 !== '' ? row.__EMPTY_10 : "").toString(),
          "description": row.__EMPTY_11 !== undefined && row.__EMPTY_11 !== null && row.__EMPTY_11 !== '' ? (row.__EMPTY_6 !== undefined && row.__EMPTY_6 !== null && row.__EMPTY_6 !== '' ? (row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "") : row.__EMPTY_11 + " " + (row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "")) : (row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : ""),
          "note": row.__EMPTY_14 !== null ? row.__EMPTY_14 : ''
        })
      } else if (row.__EMPTY_1 === "AZ" || row.__EMPTY_1 === "XO") {
        temp_array.push(...tempArray, {
          "BRTrnType": row.__EMPTY_1,
          "benefName": row.__EMPTY_4,
          "PMTCUSTID": row.__EMPTY_3 !== null && row.__EMPTY_3 !== undefined ? "#"+ row.__EMPTY_3 : '',
          "benefAcc": row.__EMPTY_5,
          "benefTIN": row.__EMPTY_6 !== null ? row.__EMPTY_6 : '',
          "benefBankCode": row.__EMPTY_7,
          "dxaClassCode": null,
          "dxaOrgCode": null,
          "infoToBenef": row.__EMPTY_13 !== null ? row.__EMPTY_13 : '',
          "mainDetail": row.__EMPTY_6 !== undefined && row.__EMPTY_6 !== null && row.__EMPTY_6 !== '' ? "" : row.__EMPTY_11,
          "amount": (row.__EMPTY_10 !== undefined && row.__EMPTY_10 !== null && row.__EMPTY_10 !== '' ? row.__EMPTY_10  : "").toString(),
          "description": row.__EMPTY_11 !== undefined && row.__EMPTY_11 !== null && row.__EMPTY_11 !== '' ? (row.__EMPTY_6 !== undefined && row.__EMPTY_6 !== null && row.__EMPTY_6 !== '' ? (row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "") : row.__EMPTY_11 + " " + (row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "")) : (row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : ""),
          "note": row.__EMPTY_14 !== null ? row.__EMPTY_14 : ''
        })
      } else if (row.__EMPTY_1 === "XT") {
        temp_array.push(...tempArray, {
          "BRTrnType": row.__EMPTY_1,
          "benefName": '',
          "PMTCUSTID": row.__EMPTY_3 !== null && row.__EMPTY_3 !== undefined ? "#"+row.__EMPTY_3 : '',
          "benefAcc": row.__EMPTY_5,
          "benefTIN": "",
          // "benefTIN": row.__EMPTY_6 !== null ? row.__EMPTY_6 : '',
          "benefBankCode": '',
          "dxaClassCode": row.__EMPTY_8,
          "dxaOrgCode": row.__EMPTY_9,
          "infoToBenef": row.__EMPTY_13 !== null ? row.__EMPTY_13 : '',
          "mainDetail": "",
          // "mainDetail": row.__EMPTY_11,
          "amount": (row.__EMPTY_10 !== undefined && row.__EMPTY_10 !== null && row.__EMPTY_10 !== '' ? row.__EMPTY_10  : "").toString(),
          "description": row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "",
          "note": row.__EMPTY_14 !== null ? row.__EMPTY_14 : ''
        })
      } else if (row.__EMPTY_1 === "XV") {
        temp_array.push(...tempArray, {
          "BRTrnType": row.__EMPTY_1,
          "benefName": row.__EMPTY_4,
          "PMTCUSTID": row.__EMPTY_3 !== null && row.__EMPTY_3 !== undefined ? "#"+row.__EMPTY_3 : '',
          "benefAcc": "",
          "benefTIN": row.__EMPTY_6 !== null ? row.__EMPTY_6 : '',
          "benefBankCode": '',
          "dxaClassCode": "",
          "dxaOrgCode": "",
          "infoToBenef": row.__EMPTY_13 !== null ? row.__EMPTY_13 : '',
          "mainDetail": "",
          // "mainDetail": row.__EMPTY_11,
          "amount": (row.__EMPTY_10 !== undefined && row.__EMPTY_10 !== null && row.__EMPTY_10 !== '' ? row.__EMPTY_10 : "").toString(),
          "description": row.__EMPTY_12 !== undefined && row.__EMPTY_12 !== null && row.__EMPTY_12 !== '' ? row.__EMPTY_12 : "",
          "note": row.__EMPTY_14 !== null ? row.__EMPTY_14 : ''
        })
      }}

    })

    setTempArray(temp_array)

    const resp= await uploadPayment(language,
      {
        "batchName": packageName,
        "CUSTACC": fromBranch?.IBAN,
        "CUSTCIF":getCurrentCompany().customerNo,
        "ccyType": fromBranch?.CCY_NAME,
        "fileName": packageName,
        "mimeType": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "trnList": temp_array
      })
        if (resp.status === "SUCCESS"){
          fetchData()
          setButtonLoading(false)
          setpackModalVisible(false)
          

        }else{
          fetchData()
          setButtonLoading(false)
          setpackModalVisible(false)

        }

      

  }



  const checkTransfer = async () => {
    setLoadCheck(true)
    const data = await checkTransferData(language,{
      "packages": packageNumberForCheck
    })

    if (data?.status === 'SUCCESS') {
      setCheckedList([])
      setpackageNumberForCheck([])
      setPackageNumberForDelete([])
      setDisabledDelete(true)
      setDisabledXLS(true)
      getData(startDate, endDate)
    }
    setLoadCheck(false)
    setExpandedKeys([])
    return data
  }



  const createPaymentFooter = async () => {
    setLoadCreate(true)
    settableLoading(true)
    const data = await createPayment(language,{
      packageNumber,
      "trnRequestType": "SAVE"
    })
    if (data.status === 'SUCCESS') {
      setCheckedList([])
      setPackageNumberForDelete([])
      setDisabledXLS(true)
      setDisabledDelete(true)

      setpackageNumberForCheck([])

      setShowSuccessOrError(true)
      setPopupType("success")
      setModalText(t("notification.batchCreated"))
      setpackageNumber([])
     
      getData(startDate, endDate)
    }
    settableLoading(false)
    setExpandedKeys([])
    setLoadCreate(false)
  }

  const rowClassName = (record: any, index: number) => {
    return index % 2 ? 'table-row-light' : 'table-row-dark';
  }
  const footerDeleteModalALL = () => (
    <>
      <div className={"flex justify_between align_center"}>
        <Button style={
          {
            width: 132,
            padding: 20,
            bottom: 21
          }
        } onClick={() => { setDeleteModal(false) }} className={'light-button  refresh_btn next_modal_cancel_btn btn flex align_center justify_center'}>
          Xeyr
        </Button>
        <Button
          style={
            {
              width: 132,
              padding: 0,
              height: 41,
              bottom: 21
            }
          }
          onClick={() => handleDelete()} className={"button blue-button"}>
          Bəli
        </Button>
      </div>
    </>
  )


  const handleDelete = async () => {
    setDeleteModal(false)

    if (packageNumberForDelete.length !== 0) {
      const data = await deletePayment(language,{
        "packages": packageNumberForDelete
      })

      if (data.status === 'SUCCESS') {
        setpackageNumberForCheck([])
        setCheckedList([])
        setpackageNumber([])
        setpackageNumberForCheck([])
        setPackageNumberForDelete([])
        setDisabledDelete(true)
        setDisabledXLS(true)
        getData(startDate, endDate)
      }
    } else {

      const data = await deletePayment(language,{
        "packages": [
          {
            "packageNumber": packageNumberInner,
            "trnList": innerCheckList
          }
        ]

      })

      if (data.status === 'SUCCESS') {

        setpackageNumberForCheck([])
        setCheckedList([])
        setpackageNumber([])
        setpackageNumberForCheck([])
        setPackageNumberForDelete([])
        setDisabledDelete(true)
        setDisabledXLS(true)
        await getPayment(packageNumberInner,'deleteInner')
        // refreshInnerTable(packageNumberInner)
      }
    }
  }

  return (
    <>
     <Row>
      <Col span={24}>
      <Col
      // flex={'900px'}
        // flex={'1350px'}
        style={{
          minHeight:1,
          border:'none',
          backgroundColor: '#fff',
          borderRadius: 10,
        }}
        className="transfers transfers--mass"
      >
        <TransfersHeader
          removeFile={() => handleReset('file')}
          endDate={endDate}
          changeEndDate={(e) => setEndDate(e)}
          startDate={(e) => setStartDate(e)}
          buttonLoading={buttonLoading}
          modalVisible={packModalVisible}
          fileList={() => setTempArray([])}
          onSelectChange={(value: number) => setPageSize(value)}
          onOkCreateTransfer={onOkCreateTransfer}
          onClick={getData}
          applyLoading={applyLoading}
        />
  </Col>
        <TableComponent

          className="transfer-table main_table_mass transfer-table--mass salary-table transfers-table__component "
          columns={columnsData}
          rowSelection={rowSelection}
          data={tableList}
          rowClassName={rowClassName}
          hideSelectAll={true}
          columnTitle={<TabsInfoIco />}
          pagination={true}
          onPageChange={(page: number) => setCurrent(page)}
          current={current}
          pageSize={pageSize}
          position="bottom center"
          alignment="center"
          onRow={(record: any, rowIndex: string) => {
            return {
              onClick: () => onRow(record),
            }
          }}
          onCell={onCell}
          onExpand={onExpand}
          expandedRowKeys={expandedKeys}
          expandable={{
            expandIconColumnIndex: 11,
            showExpandColumn: true,
            expandedRowRender: (record: any) => (
              <div className="inner--table">
                <Row style={{ alignItems: 'center', padding: '20px 0px', justifyContent:'space-between' }}>
                  <Col span={8} offset={7}>
                    <ul className="d-flex inner--table_stat">
                      <li>
                        Cəmi köçürmələr<span className="success-count">{allinnerData.length}</span>
                      </li>
                      <li>
                        Uğursuz <span className="error-count">{erroredData.length}</span>
                      </li>
                    </ul>
                  </Col>
                  <Col span={2} offset={6}>
                    <CustomTooltip title={t("transfers.refreshStatusTooltip")}>
                      <Button
                        size={'large'}
                        icon={!statusLoading ? <InnerReloadIco /> : ''}
                        style={{ right: 27,borderRadius:10 }}
                        loading={statusLoading}
                        disabled={packageStatus=='BATCH_CHECK_WAITING' || packageStatus === 'EXPIRED' || packageStatus === 'CLOSED' || packageStatus === 'DELETED'}
                        className={`blue-button  btn flex align_center justify_center ${packageStatus=='BATCH_CHECK_WAITING' || packageStatus === 'EXPIRED' || packageStatus === 'CLOSED' || packageStatus === 'DELETED' ? 'disabled-mass' : "" }`}
                        onClick={() => getPayment(record,"refresh")}
                      >
                        {t("transfers.refreshStatus")}
                      </Button>
                    </CustomTooltip>

                  </Col>
                </Row>
                <InnerTable
                  rowSelection={rowSelectionInner}
                  innerData={innerTableData}
                  pageSize={pageSize}
                  pdfLoading={loadingPdfinner}
                  handleGetFileClick={(lang, e) => handleGetPdfSingleInner(lang, e)}

                />
              </div>
            ),

            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <Button
                  style={{ marginLeft: 3 }}
                  icon={<ArrowUpIco />}
                  className="transfers-arrow-down transparent"
                  onClick={(e) => onExpand(record, e, "")}
                />
              ) : (
                <Button
                  style={{ marginLeft: 3 }}
                  icon={<ArrowDownIco />}
                  className="transfers-arrow-down transparent"
                  onClick={(e) => onExpand(record, e, "")}
                />
              ),
          }}
        />
        {tableList?.length === 0 && <div className={'noDataTransfer'}>
          <div className={'noDataTransferDiv'}>{t("transfers.informationNotAvailable")}</div>
        </div>}

        {tableList?.length > 0 && (
          <TransfersFooter
            createDisabled={createDisabled }
            disabled={tableList.length === 0 || checkedTransfers.length > 1 || checkedTransfers.length === 0 || selectedRowKeys.length === 0 || checkDisabled}
            checkTransfer={checkTransfer}
            loadCreate={loadCreate}
            disablePDF={disablePDF}
            disableDelete= {disableDelete}
            disabledXLS={disabledXLS}
            loadCheck={loadCheck}
            selectedRow={singlePdf}
            handleGetExcelAdditional={(e)=>handleGetExcelPackage(e)}
            loadingExcel={loadingExcel}
            handleGetFileClick={(e) => handleGetPdfSingle(e)}
            handleGetFileClickMultiple={(e) => handleGetPdfMultiple(e)}
            handleDelete={() => setDeleteModal(true)}
            loadingPdf={loadingPdf}
            createPayment={createPaymentFooter}
          />)}
    
      {
        deleteModalvisible &&
        <Modal
          open={deleteModalvisible}
          title={'Diqqət!'}
          // onOk={()=>handleDelete()}
          onCancel={() => { setDeleteModal(false) }}
          footer={footerDeleteModalALL()}
          // width={450}
          closeIcon={<ModalCloseIco />}
          style={{ fontSize: 18, textAlign: "center", fontWeight: 500 }}
          className={'deleteAll'}
        >

          {packageNumberForDelete?.length > 0 ? <p>Silinəcək köçürmələrin sayı:<span style={{ color: '#015CD1', fontWeight: '700' }}>{packageNumberForDelete?.length > 0 ? deletedTransfersLength : innerCheckList?.length}!</span> Silinsin?</p> : <p>Silinəcək köçürmələrin sayı:<span style={{ color: '#015CD1', fontWeight: '700' }}>{packageNumberForCheck?.length > 0 ? packageNumberForCheck?.length : innerCheckList?.length}!</span> Silinsin?</p>}
        </Modal>
      }
      {showSuccessOrError && (
        <SuccessOrErrorModal
          visible={showSuccessOrError}
          modalType={popupType}
          modalTitle={popupType === 'success' ? t("home.transfer") : t("notification.attention")}
          modalText={modalText}
          onCancel={() => { setShowSuccessOrError(false);setCreateDisabled(true) }}
          onClose={() => { setShowSuccessOrError(false);setCreateDisabled(true) }}
        />
      )}
      {
        tableLoading ? <FullScreenLoading /> : <></>
      }
      </Col>
     </Row>
      
    </>
  )
}
export default connect(null, null)(Transfers)
